// extracted by css-extract-rspack-plugin
export default {"ProfileLink":"UmDjH"};